import React from 'react';
import InvestorDashboardSC from './investor-dashboard.styled';
import InfoBanner from '../../../components/info-banner';
import InvestorDashBanner from '../../../components/investor-dash-banner';
import ContentWrap from '../../../components/content-wrap';
import InvestorDashContent from '../../../components/investor-dash-content';

const InvestorDashboard = () => {
  return (
    <InvestorDashboardSC>
      <InfoBanner>
        <InvestorDashBanner withInvChart />
      </InfoBanner>
      <ContentWrap>
        <InvestorDashContent />
      </ContentWrap>
    </InvestorDashboardSC>
  );
};

export default InvestorDashboard;
